import styles from "../css/ContainerNavigationView.module.css";
import { useTranslation } from "react-i18next";
import IconButton from "../../../components/ui/IconButton";

interface ContainerNavigationViewProps {
  open: boolean;
  title?: string;
  titleView?: React.ReactNode;
  titleButtonString?: string;
  leftButtonText?: string;
  leftImageButtonImage?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  rightTextButtonText?: string;
  rightTextButtonColor?: string;
  onClickLeftImageButton?: () => void;
  onClickTitleButton?: () => void;
  onClickRightTextButton?: () => void;
}

export default function ContainerNavigationView(
  props: ContainerNavigationViewProps
) {
  const { t } = useTranslation();

  if (!props.open) return null;

  const LeftIcon = props.leftImageButtonImage;

  return (
    <>
      <div className={styles.container}>
        <div className={styles.leftButtonContainer}>
          {props.leftButtonText !== undefined && (
            <span className={styles.textButton}>{props.leftButtonText}</span>
          )}
          {LeftIcon !== undefined && (
            <IconButton
              aria-label={t("CloseButton")}
              icon={<LeftIcon className={styles.leftIcon} />}
              onClick={props.onClickLeftImageButton}
            />
          )}
        </div>
        <div className={styles.centerContainer}>
          {props.titleView !== undefined && (
            <div className={styles.titleViewContainer}>{props.titleView}</div>
          )}

          {props.titleView === undefined &&
            props.titleButtonString !== undefined && (
              <button
                type="button"
                className={styles.titleButtonContainer}
                onClick={props.onClickTitleButton}
              >
                <span className={styles.titleButtonString}>
                  {props.titleButtonString}
                </span>
              </button>
            )}

          {props.titleView === undefined &&
            props.titleButtonString === undefined && (
              <span className={styles.titleText}>{props.title}</span>
            )}
        </div>
        <div className={styles.rightButtonContainer}>
          {props.rightTextButtonText !== undefined && (
            <button
              type="button"
              className={styles.textButton}
              style={{ color: props.rightTextButtonColor ?? undefined }}
              onClick={props.onClickRightTextButton}
            >
              {props.rightTextButtonText}
            </button>
          )}
        </div>
      </div>
    </>
  );
}
